import { Pause, Play, Reset } from "assets/icons/Common";
import { Col, IconButtonInverted, Row } from "components/primitives";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { WidgetFC } from "types/Widget";

export interface StopwatchState {
  currentTime: number;
}

const maxTime = 5999; // 99 * 60 + 99

export const Stopwatch: WidgetFC<StopwatchState> = ({ state: { currentTime }, setState }) => {
  // const [currentTime, setCurrentTime] = useState(0);
  const [playTimestamp, setPlayTimestamp] = useState<number>();

  const isCounting = Boolean(playTimestamp);

  useEffect(() => {
    const interval = setInterval(updateTimer, 100);
    return () => clearInterval(interval);
  });

  const updateTimer = () => {
    if (isCounting) {
      if (currentTime < maxTime) {
        const newCurrentTime = Math.min((Date.now() - playTimestamp!) / 1000, maxTime);
        setState({ currentTime: newCurrentTime });

        if (newCurrentTime >= maxTime) {
          setPlayTimestamp(undefined);
        }
      }
    }
  };

  const playPause = () => {
    if (isCounting) {
      //pause
      setPlayTimestamp(undefined);
    } else {
      //Play - adjust the timestamp by the difference between the set time and the current time if we're paused
      setPlayTimestamp(Date.now() - currentTime * 1000);
    }
  };

  const stop = () => {
    if (playTimestamp) {
      setPlayTimestamp(undefined);
    }
    setState({ currentTime: 0 });
  };

  return (
    <OuterContainer>
      <TimerContainer>
        <p style={{ width: "1.5em", textAlign: "right" }}>{`${String(
          Math.floor(currentTime / 60),
        ).padStart(2, "0")}`}</p>
        <p>:</p>
        <p style={{ width: "1.5em", textAlign: "left" }}>{`${String(
          Math.floor(currentTime) % 60,
        ).padStart(2, "0")}`}</p>
      </TimerContainer>
      <ControlsContainer>
        <ControlButton
          disabled={currentTime === 0}
          withShadow={false}
          Icon={Reset}
          accentColor="var(--danger)"
          onClick={stop}
        />
        <ControlButton
          disabled={currentTime === maxTime}
          withShadow={false}
          Icon={isCounting ? Pause : Play}
          onClick={playPause}
        />
      </ControlsContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  padding: 5cqw;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;

  --animate-duration: 0.5s;
`;

const ControlsContainer = styled.div`
  height: 23cqh;
  width: 100%;
  position: absolute;
  bottom: 3cqh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;

  button {
    height: 100%;
  }
`;

const TimerContainer = styled(Row)`
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 1cqw;

  p {
    font-size: 16cqw;
    line-height: 16cqw;
    color: var(--secondary);
  }
`;

const ControlButton = styled(IconButtonInverted)`
  aspect-ratio: 1;
  padding: 3cqw;
`;
